angular.module('qbePortal').
controller('ErrorController', [
	'$scope',
	'$state',
	'$stateParams',
	'$sce',
	'labelService',
	'Util',
	'MODULE_INFO',
	function($scope, $state, $stateParams, $sce, labelService, Util, MODULE_INFO) {
		var $ctrl = this ;
		$scope.$root.$broadcast('loading-animation-end');

		$ctrl.title = 'Error';
		// $scope.$root.$broadcast('page-title-set', $ctrl.title);
		Util.dispatchCustomEvent('register-labels');

		if ( $stateParams.errorMessage )
			console.error($stateParams.errorMessage, $stateParams.response);

		$ctrl.errorMessage = $sce.trustAsHtml(labelService.getLabelFor('defaultErrorMessage'));
		$ctrl.defaultErrorTitle = labelService.getLabelFor('defaultErrorTitle');
		$ctrl.tryAgainLinkMessage = labelService.getLabelFor('tryAgainLinkMessage');
		$ctrl.retry= function() {
			$state.go(MODULE_INFO.startRouteName);
		}; 
}]);
